var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.messages.length > 0)?_c('div',{staticClass:"dynamic-messages"},_vm._l((_vm.messages),function(message,index){return _c('TixMessage',{key:index,attrs:{"template":message.message,"type":message.style}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }